export const LOGO_HUB = 'https://static.publ.site/logo_hub.png' as const;
export const LOGO_HUB_WHITE = 'https://static.publ.site/logo_hub_w.png' as const;
